import React from "react";
import { observer } from "mobx-react";
import { EsignatureWebhookEventViewStore } from "../../store";
import { EsignatureWebhookEventViewForm } from "./EsignatureWebhookEventViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type EsignatureWebhookEventViewProps = {
  esignatureWebhookEventViewStore: EsignatureWebhookEventViewStore;
};

export const EsignatureWebhookEventView: React.FC<EsignatureWebhookEventViewProps> =
  observer(({ esignatureWebhookEventViewStore }) => {
    return (
      <div>
        <EsignatureWebhookEventViewForm
          providerOptions={esignatureWebhookEventViewStore.getProviderOptions()}
          provider={esignatureWebhookEventViewStore.providerValue}
          externalEventId={esignatureWebhookEventViewStore.externalEventIdValue}
          eventType={esignatureWebhookEventViewStore.eventTypeValue}
          documentExternalId={
            esignatureWebhookEventViewStore.documentExternalIdValue
          }
          processedAt={esignatureWebhookEventViewStore.processedAtValue}
          error={esignatureWebhookEventViewStore.errorValue}
          onPrint={(handlePrint: () => void) =>
            esignatureWebhookEventViewStore.printEsignatureWebhookEvent(
              handlePrint
            )
          }
          onCancel={() =>
            esignatureWebhookEventViewStore.cancelEsignatureWebhookEvent()
          }
          onEdit={
            esignatureWebhookEventViewStore.isEditEnabled
              ? () =>
                  esignatureWebhookEventViewStore.editEsignatureWebhookEvent()
              : undefined
          }
        />
        <ErrorDialog
          open={esignatureWebhookEventViewStore.errorDialogOpened}
          title={esignatureWebhookEventViewStore.errorTitle}
          description={esignatureWebhookEventViewStore.errorDescription}
          onClose={() => esignatureWebhookEventViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
